<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="items"
      :total-items="total"
      :pagination="pagination"
      :rows-per-page-items="[10, 25, 50]"
      :loading="loading"
      @update:pagination="$emit('update:pagination', $event)"
    >
      <template #items="{ item }">
        <td>{{ item.name }}</td>
        <td :style="{ display: 'flex', gap: '4px', alignItems: 'center' }">
          <div>{{ item.url }}</div>
          <ClipboardProvider v-slot="{ copy, copied }" :value="item.url">
            <div>
              <v-tooltip right :color="copied ? 'success' : undefined" :value="copied">
                <template #activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    :color="copied ? 'success' : 'grey'"
                    class="ma-0"
                    v-on="on"
                    @click="copy()"
                  >
                    <v-icon small>{{ copied ? 'check' : 'content_copy' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ copied ? $t('Copied') : $t('click_to_copy') }}</span>
              </v-tooltip>
            </div>
          </ClipboardProvider>
        </td>
        <td>{{ item.createdAt | DateFormat('DD/MM/YYYY HH:mm') }}</td>
        <td>
          <ItemMenu @select="$emit($event, item)" />
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ClipboardProvider from '@/components/providers/ClipboardProvider'
import ItemMenu from './ItemMenu'

export default {
  components: {
    ClipboardProvider,
    ItemMenu
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { value: 'name', text: this.$t('link_name'), sortable: false },
        { value: 'url', text: 'URL', sortable: false },
        { value: 'created_at', text: this.$t('created_date'), sortable: false },
        { sortable: false }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/my-allianz/LinkManagement/DataTable.vue